import { FAB, Filters } from '@desquared/wave-components-library';
import styles from './FiltersFAB.module.css';

export default function FiltersFAB({ onClick }) {
  return <FAB className={styles.container} renderIcon={() => <Filters />} onClick={onClick} variant={'primary'} />;
}
